import { ACTIVE_URL } from '../config';
import { extractErrorMessage } from '../utils/errorHandling';

const API_BASE_URL = `${ACTIVE_URL}/api/v1`;

const refreshAccessToken = async (): Promise<string | null> => {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) return null;

  const res = await fetch(`${API_BASE_URL}/auth/refresh/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (!res.ok) return null;

  const data = await res.json();
  localStorage.setItem('access_token', data.access);
  if (data.refresh) {
    localStorage.setItem('refresh_token', data.refresh);
  }
  return data.access;
};

export const apiFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  let response: Response;
  
  try {
    response = await fetch(url, options);
  } catch (err: any) {
    window.dispatchEvent(new CustomEvent('api_error', { detail: err.message || 'Network Error' }));
    throw err;
  }

  if (response.status === 401) {
    const newToken = await refreshAccessToken();

    if (!newToken) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/';
      return response;
    }

    const retryOptions: RequestInit = {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${newToken}`,
      },
    };
    try {
      response = await fetch(url, retryOptions);
    } catch (err: any) {
      window.dispatchEvent(new CustomEvent('api_error', { detail: err.message || 'Network Error' }));
      throw err;
    }
  }

  if (!response.ok && response.status !== 401) {
    try {
      const clone = response.clone();
      const errorData = await clone.json();
      const errorMsg = extractErrorMessage(errorData);

      window.dispatchEvent(new CustomEvent('api_error', { detail: errorMsg }));
    } catch (e) {
      window.dispatchEvent(new CustomEvent('api_error', { detail: response.statusText || 'API Request Failed' }));
    }
  }

  return response;
};
